import script from "./BoutiqueView.vue?vue&type=script&setup=true&lang=js"
export * from "./BoutiqueView.vue?vue&type=script&setup=true&lang=js"

import "./BoutiqueView.vue?vue&type=style&index=0&id=62fe5793&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62fe5793"]])

export default __exports__